import React, { useEffect, useState } from "react";
import { Upload, message, Select, Spin } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";

const { Dragger } = Upload;
const { Option } = Select;

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

const LogoUploadComponent = ({ value, onChange, disabled }) => {
  const [logoList, setLogoList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [loadingLogos, setLoadingLogos] = useState(false);

  useEffect(() => {
    fetchLogos();
  }, []);

  const fetchLogos = async () => {
    setLoadingLogos(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/logos`);
      setLogoList(res.data.logos || []);
    } catch {
      message.error("Fehler beim Laden der Logos.");
    } finally {
      setLoadingLogos(false);
    }
  };

  const beforeUpload = (file) => {
    const isJpg = file.type === "image/jpeg" || file.type === "image/jpg";
    const isLt5M = file.size <= MAX_FILE_SIZE;
    if (!isJpg) {
      message.error("Nur JPG/JPEG-Dateien sind erlaubt.");
    }
    if (!isLt5M) {
      message.error("Die Datei darf maximal 5 MB groß sein.");
    }
    return isJpg && isLt5M;
  };

  const handleUpload = ({ file }) => {
    const reader = new FileReader();
    reader.onload = async () => {
      const base64 = reader.result.split(",")[1];
      setUploading(true);
      try {
        await axios.post(`${process.env.REACT_APP_API_URL}/upload-logo`, {
          filename: file.name,
          base64,
        });
        message.success("Logo erfolgreich hochgeladen.");
        await fetchLogos();
        onChange(file.name);
      } catch (err) {
        message.error(err.response?.data?.error || "Fehler beim Hochladen.");
      } finally {
        setUploading(false);
      }
    };
    reader.readAsDataURL(file);
  };

  return (
    <div style={{ marginBottom: 24 }}>
      <Dragger
        accept=".jpg,.jpeg"
        customRequest={handleUpload}
        showUploadList={false}
        beforeUpload={beforeUpload}
        disabled={uploading || disabled}
        style={{ marginBottom: 16 }}
      >
        <p className="ant-upload-drag-icon">
          <UploadOutlined />
        </p>
        <p className="ant-upload-text">
          JPG/JPEG-Datei per Drag & Drop hierher ziehen oder klicken
        </p>
        <p className="ant-upload-hint">Maximal 5 MB</p>
      </Dragger>

      <Spin spinning={loadingLogos}>
        <Select
          showSearch
          placeholder="Logo auswählen"
          optionFilterProp="children"
          value={value}
          onChange={onChange}
          disabled={disabled}
          style={{ width: "100%" }}
          filterOption={(input, option) =>
            option.children[1].toLowerCase().includes(input.toLowerCase())
          }
        >
          {logoList.map((logo) => {
            const url = `${
              process.env.REACT_APP_API_URL
            }/logo/${encodeURIComponent(logo)}`;
            return (
              <Option key={logo} value={logo}>
                <span style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={url}
                    alt={logo}
                    style={{
                      width: 60,
                      height: 40,
                      objectFit: "contain",
                      marginRight: 8,
                      border: "1px solid #ddd",
                      padding: 2,
                      background: "#fff",
                    }}
                  />
                  <span>{logo}</span>
                </span>
              </Option>
            );
          })}
        </Select>
      </Spin>
    </div>
  );
};

export default LogoUploadComponent;
